import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared.module';
import { DialogAlertConfirmComponent } from './dialog-alert-confirm.component';



@NgModule({
  declarations: [DialogAlertConfirmComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [DialogAlertConfirmComponent]
})
export class DialogAlertConfirmModule { }
